import { render, staticRenderFns } from "./SearchResultNormal.vue?vue&type=template&id=2c6c4fdf&scoped=true&"
import script from "./SearchResultNormal.vue?vue&type=script&lang=js&"
export * from "./SearchResultNormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c4fdf",
  null
  
)

export default component.exports